import {IAbstractModel} from '../IAbstractModel';
import {IOrderModel} from './IOrderModel';

export enum OrderPropertiesName {
    HAS_NEW_COMPLETED_PRODUCT = 'has-new-completed-product',
    NAME_LAST_PRODUCT_NUMBER = 'last-product-number',
}

export interface IOrderPropertyModel<TVal = any> extends IAbstractModel {
    name: OrderPropertiesName;
    value?: TVal | null;
    context?: Record<string, any> | null;

    order?: IOrderModel;
}
